import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Point, User } from 'rest-client';

import { OfferStateModel } from '@app/modules/core/states/offer-state/offer.model';

const ZERO = 0;
const PROMO_SUCCESS = 1;
const PROMO_FAILED = 0;

@Component({
  selector: 'bkg-summary-discounts',
  templateUrl: './summary-discounts.component.html',
})
export class SummaryDiscountsComponent {
  @Input() userData: User;
  @Input() offerData: OfferStateModel;
  @Input() promoLoaded: number;
  @Input() isLoadingPromo: boolean;
  @Input() isLoadingCode: boolean;
  @Input() promoCode: string;

  @Output() modifyDiscountsReturn = new EventEmitter<void>();
  @Output() addRedeemReturn = new EventEmitter<void>();
  @Output() addPromoCodeReturn = new EventEmitter<string>();
  @Output() closeFailPromoReturn = new EventEmitter<void>();

  get hasPoints(): boolean {
    return !!this.userData?.points;
  }

  get canUsePoints(): boolean {
    return this.userPoints > 0;
  }

  get userPoints(): number {
    const total = this.userData?.points?.reduce(function (
      prev: number,
      cur: Point
    ) {
      return Number(prev) + Number(cur.points);
    },
    0);
    return total;
  }

  get pointsApplied(): boolean {
    return this.offerData?.offer?.pvp_product_points > ZERO;
  }

  get appliedPoints(): number {
    return this.offerData?.offer?.pvp_product_points;
  }

  get promoSuccess(): boolean {
    return (
      !!this.offerData?.offer?.promos?.length &&
      !this.offerData?.offer?.promos?.[0]?.error &&
      this.promoLoaded === PROMO_SUCCESS
    );
  }

  get promoFailed(): boolean {
    return (
      (!!!this.offerData?.offer?.promos.length &&
        this.promoLoaded === PROMO_FAILED) ||
      (!!this.offerData?.offer?.promos?.length &&
        !!this.offerData?.offer?.promos?.[0]?.error &&
        this.promoLoaded === PROMO_FAILED)
    );
  }

  onClickModifyDiscounts(): void {
    this.modifyDiscountsReturn.emit();
  }

  onClickRedeem(): void {
    this.addRedeemReturn.emit();
  }

  onClickValidatePromoCode(): void {
    this.addPromoCodeReturn.emit(this.promoCode);
  }

  onCloseFailPromo(): void {
    this.closeFailPromoReturn.emit();
  }
}
